import type { SingleCoverage } from "../../../data-model/medicalPaOrdersModel";

/**
 * Returns whether a single Postgres coverage row was manually edited by a user.
 *
 * @param coverageRow - One coverage record from the order payload
 * @returns True when `updated_by` is a non-empty string
 */
export const isCoverageRowManuallyUpdated = (
  coverageRow: SingleCoverage | undefined,
): boolean => (coverageRow?.updated_by ?? "").trim() !== "";

/**
 * Returns whether any coverage row on the order was manually edited.
 * Used for order-level UI such as the header badge and refresh gating.
 *
 * @param coverageRows - All coverage records for the order
 * @returns True when at least one row has a non-empty `updated_by`
 */
export const hasAnyManuallyUpdatedCoverage = (
  coverageRows: SingleCoverage[] | undefined,
): boolean =>
  (coverageRows ?? []).some((row) => isCoverageRowManuallyUpdated(row));
